import { useLayoutEffect, useRef, useState } from 'react';

// Below this an analyst report's filter bar and first table do not fit; the page scrolls instead.
const MIN_HEIGHT_PX = 560;

/**
 * An analyst report (a standalone HTML document) filling the content area edge to edge, from under
 * the header to the bottom of the window, scrolling inside itself like the standalone file does.
 * The sandbox gives it scripts and downloads only: it runs on an opaque origin, so it cannot read
 * the agent key.
 */
export function ReportFrame({ title, srcDoc }: { title: string; srcDoc: string }) {
  const box = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>();

  useLayoutEffect(() => {
    const fit = () => {
      const top = (box.current?.getBoundingClientRect().top ?? 0) + window.scrollY;
      setHeight(Math.max(MIN_HEIGHT_PX, Math.floor(window.innerHeight - top)));
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, []);

  return (
    <div ref={box} className="-mx-6 -my-6 bg-[#0F1319]">
      <iframe
        title={title}
        srcDoc={srcDoc}
        sandbox="allow-scripts allow-downloads"
        className="block w-full border-0"
        style={{ height }}
      />
    </div>
  );
}
